/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { User } from '../../core/_models'
import { useNavigate } from 'react-router-dom'

type Props = {

    user: User,

}

const NameCell: FC<Props> = ({ user }) => {

    const id = String(user.id) as string;

    const navigate = useNavigate()

    const handleToShow = () => navigate(`/admin/users/${id}/edit`)

    return <div className='d-flex align-items-center'>
        <div className='d-flex flex-column'>
            <span role='button' className='text-gray-800 text-hover-danger mb-1' onClick={() => handleToShow()}>
                {user.name}
            </span>
        </div>
    </div>
}

export { NameCell }